import React, { Component } from 'react';
import { MainContent, Content } from 'client/components/App';
import { Helmet } from 'react-helmet';
import BeRemoteErrorAlert from 'client/components/Be/BeRemoteErrorAlert';
import { connect } from 'react-redux';
import * as indexActions from 'client/redux/endpoint/log/indexActions';
import EndpointLogTable from 'client/components/EndpointLog/components/EndpointLogTable';
import { getStateSearch } from 'client/redux/apiHelpers';
import _ from 'lodash';

class EndpointLogIndex extends Component {

  constructor (props) {
    super(props);
    this.getDataDebounced = _.debounce(this.getData, 200);
  }

  componentDidMount () {
    const filter = {...this.props.filter, ...this.props.search};
    return this.handleFilter(filter);
  }

  getData = (overrideWith = {}) => {
    const { orderBy, orderDirection, page, filter } = this.props;
    return this.props.endpointLogIndex({...filter, orderBy, orderDirection, page, ...overrideWith});
  };

  handleOrderBy = (orderBy, orderDirection) => {
    this.props.endpointLogIndexOrderBy(orderBy, orderDirection);
    return this.getData({orderBy, orderDirection});
  };

  handleSetPage = page => {
    if (this.props.page === page) return;
    this.props.endpointLogIndexSetPage(page);
    return this.getData({page});
  };

  handleFilter = newFilter => {
    this.props.endpointLogIndexFilter(newFilter);
    return this.getDataDebounced(newFilter);
  };

  renderTitle () {
    return (
      <Helmet>
        <title>Endpoint Log Overview</title>
      </Helmet>
    );
  }

  renderError (error) {
    return (
      <Content>
        {this.renderTitle()}
        <MainContent>
          <BeRemoteErrorAlert error={error} />
        </MainContent>
      </Content>
    );
  }

  render () {
    const { isReading, logs, orderBy, orderDirection, page, pages, limit, offset, count, filter, error } = this.props;
    if (error) return this.renderError(error);
    return (
      <Content>
        <MainContent>
          {this.renderTitle()}
          <EndpointLogTable
            className="panel-default panel-border"
            loading={isReading}
            onOrderBy={this.handleOrderBy}
            onSetPage={this.handleSetPage}
            orderBy={orderBy}
            orderDirection={orderDirection}
            onFilter={this.handleFilter}
            onRefresh={this.getData}
            filter={filter}
            logs={logs}
            count={count}
            limit={limit}
            offset={offset}
            page={page}
            pages={pages}
          />
        </MainContent>
      </Content>
    );
  }

}

const mapStateToProps = state => ({
  ...state.endpoint.logIndex,
  search: getStateSearch(state),
});

export default connect(mapStateToProps, indexActions)(EndpointLogIndex);
